import ProductStockConnector from './productStock.props';
import ProductStockComponent from './productStock.component';

export default ProductStockConnector(ProductStockComponent);
